import { apiFetch, buildQuery } from "./apiClient";
import type { AccessLogItem, AccessLogListData } from "../types/api";

export interface AccessLogListParams {
  serviceAccountId?: number;
  entity?: string;
  from?: string;
  to?: string;
  limit?: number;
  offset?: number;
}

/** GET /api/v1/admin/access-logs - newest-first consumer API traffic. */
export function listAccessLogs(params: AccessLogListParams = {}): Promise<AccessLogListData> {
  return apiFetch<AccessLogListData>(`/api/v1/admin/access-logs${buildQuery(params)}`);
}

/** GET /api/v1/admin/access-logs/{id} */
export function getAccessLog(id: number | string): Promise<AccessLogItem> {
  return apiFetch<AccessLogItem>(`/api/v1/admin/access-logs/${id}`);
}
